import React from 'react';
import SolvedControlGrid from './SolvedControlGrid';

const SolvedOuterControlGrid = () => {
  return (
    <div className="outerGridContainer">
      {/* Goes 0,1,3,2 because that puts it visually in clockwise order
      (0123 starting from upper left) for the sake of the math that
      determines which grid is in which corner when the puzzle is rotated. 
      (getGridIdAccountingForPuzzleRotation) */}
      <div className="puzzleRotationContainer">
        <SolvedControlGrid gridId={0}/>

        <SolvedControlGrid gridId={1}/>

        <SolvedControlGrid gridId={3}/>

        <SolvedControlGrid gridId={2}/>
      </div>
    </div>
  );
};

export default SolvedOuterControlGrid;